import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import ConfirmationModal from '../ConfirmationModal';

const disabledDropDownItemStyle = {
  backgroundColor: 'gray',
  opacity: '0.7',
  width: '100%',
};

const defaultStyle = { width: '100%' };

export function findSelectedOption(selectedOption, options) {
  const { value } = selectedOption || {};
  if (!value) {
    return options[0];
  }
  return options.find(option => option.value === value) || {};
}

class DropdownSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      selectedOption: findSelectedOption(props.selectedOption, props.options),
      separateOption: '',
      triggeredOption: '',
      warningModalText: '',
    };
  }

  componentDidUpdate = prevProps => {
    if (prevProps.selectedOption !== this.props.selectedOption) {
      this.setState({
        selectedOption: findSelectedOption(this.props.selectedOption, this.props.options),
      });
    }
    if (prevProps.selectionTrigger !== this.props.selectionTrigger) {
      const { onSelect, selectionTrigger, options } = this.props;
      const { triggeredOption } = this.state;
      if (selectionTrigger === 'cancel') {
        this.setState({
          selectedOption: options[0],
        });
        // onSelect(options[0]);
      } else if (selectionTrigger === 'confirm') {
        this.setState({
          selectedOption: { label: 'SuperAdmin', value: 'superAdmin' },
        });
        // onSelect(triggeredOption);
      }
    }
  };

  onClose = () => {
    this.setState(prev => ({ ...prev, warningModalText: '' }));
  };

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  onOptionSelect = option => {
    const { onSelect, type, trgiggerText, warningText } = this.props;
    if (option.disabledItem) {
      const { label } = option;
      const WARNING_TEXT = `${label} ${warningText}` || `${label} not available at this time`;
      this.setState(prev => ({ ...prev, warningModalText: WARNING_TEXT }));
      return;
    }
    if (trgiggerText === option.value) {
      onSelect(option);
      this.setState({
        triggeredOption: option,
      });
    } else {
      if (type === 'user') {
        this.setState({ separateOption: option }, () => {
          onSelect(option);
        });
      } else {
        this.setState({
          selectedOption: option,
        });
        onSelect(option);
      }
    }
  };

  renderTypes = () => {
    const selectedOption = this.props.selectedOption
      ? findSelectedOption(this.props.selectedOption, this.props.options)
      : this.state.selectedOption;
    const { options, disabled } = this.props;
    return options
      .filter(option => option.value !== selectedOption.value)
      .map(numberType => {
        return (
          <DropdownItem
            disabled={disabled}
            style={numberType?.disabledItem ? disabledDropDownItemStyle : defaultStyle}
            key={numberType?.value}
            onClick={() => this.onOptionSelect(numberType)}
          >
            {numberType.label}
          </DropdownItem>
        );
      });
  };

  render() {
    const { selectedOption, dropdownOpen, warningModalText } = this.state;
    const { disabled } = this.props;
    return (
      <>
        <ConfirmationModal
          isOpen={!!warningModalText}
          bodyText={warningModalText}
          onCancel={this.onClose}
          ignoreConfirmButton
        />
        <Dropdown
          style={{ width: '100%' }}
          direction="down"
          name="type"
          isOpen={dropdownOpen}
          toggle={this.toggle}
        >
          <DropdownToggle
            outline
            disabled={disabled}
            className="dropdown-field"
            style={{ width: '100%', minHeight: 'calc(1.5em + .75rem + 2px)' }}
          >
            {this.props.selectedOption
              ? findSelectedOption(this.props.selectedOption, this.props.options).label
              : selectedOption.label}
          </DropdownToggle>
          <DropdownMenu style={{ width: '100%' }}>{this.renderTypes()}</DropdownMenu>
        </Dropdown>
      </>
    );
  }
}

DropdownSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  selectedOption: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  onSelect: PropTypes.func,
};

DropdownSelect.defaultProps = {
  options: [],
  onSelect: () => {},
};

export default DropdownSelect;
